/**
 *
 * FeeStudentCategoryTable
 *
 */
import { formatAmount } from 'core/utils/constants';
import React, { memo } from 'react';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import EncryptedStorage from 'core/utils/constants/encryptedStorage';


interface Props {
  feeStudentCategoryData: any;
}

const thClassNames = `px-4 py-3 max-w-[12mm] text-center text-md font-bold text-black uppercase tracking-wider border border-gray-300`;
const tdClassNames = `px-4 py-3 max-w-[12mm] border border-gray-300 text-center`;

export const FeeStudentCategoryTable = memo((props: Props) => {
  const authData = useAuth();
  const feeStudentCategoryData = props?.feeStudentCategoryData;

  React.useEffect(() => {
    // if (feeStudentCategoryData)
    // window.print();
    return () => {
      EncryptedStorage.removeItem('FEE_STUDENT_CATEGORY_DATA')
    }
  }, []);


  return (

    <div className=''>
      <div className='flex justify-end p-4 print:hidden'>
        {!!feeStudentCategoryData && <button className='bg-primary-main text-neutral-light px-4 py-1 rounded-lg' onClick={() => window.print()}>Print</button>}
      </div>
      <h1 className="text-2xl text-center font-bold mb-4 mt-3">Fee Table</h1>
      <table className="min-w-full divide-y divide-black border border-black">
        <thead className="bg-gray-50">
          <tr>
            <th className={thClassNames}>S. No</th>
            <th className={thClassNames}>Name</th>
            <th className={thClassNames}>Class</th>
            <th className={thClassNames}>Roll Number</th>
            <th className={thClassNames}>Admission No</th>
            <th className={thClassNames}>Parent Name</th>
            <th className={thClassNames}>Mobile No</th>
            <th className={thClassNames}>Paid Fee</th>
            <th className={thClassNames}>Due Fee</th>
            <th className={thClassNames}>Concession Fee</th>
            <th className={thClassNames}>Grand Total</th>

          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-black">
          {feeStudentCategoryData.map((student, index) => (
            <tr key={student.StudentId}>
              <td className={tdClassNames}>{index + 1}</td>
              <td
                className={tdClassNames}
              >{`${student?.StudentName}`}</td>
              <td className={tdClassNames}>
                {student?.ClassName}
              </td>
              <td className={tdClassNames}>
                {student?.RollNo ? student?.RollNo : '-'}
              </td>
              <td className={tdClassNames}>{student?.AdmissionNo ? student?.AdmissionNo : '-'}</td>
              <td className={tdClassNames}>
                {student?.ParentName ? student?.ParentName : '-'}
              </td>
              <td className={tdClassNames}>{student?.ParentMobile ? student?.ParentMobile : '-'}</td>
              <td className={tdClassNames}>{student?.Paid ? formatAmount(authData, student?.Paid) : '-'}</td>
              <td className={tdClassNames}>{student?.Due ? (formatAmount(authData, student?.Due)) : '-'}</td>
              <td className={tdClassNames}>{student?.Concession ? formatAmount(authData, student?.Concession) : '-'}</td>
              <td className={tdClassNames}>{student?.GrandTotal ? formatAmount(authData, student?.GrandTotal) : '-'}</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>


  );
});
